module.exports = __webpack_public_path__ + "static/media/sales-order-slide-1.55b4ae2a.jpg";